import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconArrowRight(rest) {
  return (
    <Icon viewBox="0 0 24 24" {...rest}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        fill="none"
        d="M17 8l4 4m0 0l-4 4m4-4H3"
      />
    </Icon>
  )
}
